import React from "react";
import "./css/myprojects.css";
import taskMasterImage from "../images/Task-master.png";
// import Portfolio from "../images/portfolio.png";
// import Bot from "../images/bots.png";
import artie from "../images/artie.png"
import insurance from "../images/insurance.png"
//import Movie from "../images/Movie.png";
import Covid from "../images/covid-tracker.png"
import Dribbly from "../images/Dribbly.png";
// import Bank from "../images/Bank.png";
import Appoint from "../images/Appointment.png"
import machine from "../images/machine.png"

const MyProjects = () => {
  const projects = [
    {
      id: 1,
      name: "Task Management ",
      imageUrl: taskMasterImage,
      websiteUrl: "https://task-lists-management.netlify.app/"
    },
    {
      // id: 2,
      // name: "Portfolio",
      // imageUrl: Portfolio,
      // websiteUrl: "https://portfolio-iryve4qli-ernesth1.vercel.app/",
      id: 2,
      name: "Appointment Analysis",
      imageUrl: Appoint,
      websiteUrl: "https://public.tableau.com/views/AppointmentData_16536261643480/DATASHOWINGATTENDANCEOFAPPOINTMENTSANDHOWTHEYAREAFFECTED?:language=en-US&:display_count=n&:origin=viz_share_link",
    },
    {
      id: 3,
      name: "Artie Clothing",
      imageUrl: artie,
      websiteUrl: "https://artieclothing.com/",
    },
    {
      id: 4,
      name: "Covid Tracker ",
      imageUrl: Covid,
      websiteUrl: "https://public.tableau.com/views/Automatedtracker_16439740448810/Covid19AutomatedTracker?:language=en-US&:display_count=n&:origin=viz_share_link",//https://ernesth1.github.io/Flatiron-Movie-Theater/
    },
    {
      id: 5,
      name: "Insurance dataset analysis and api deployment",
      imageUrl: insurance,
      websiteUrl: "https://github.com/ErnestH1/insurance_analysis",
    },
    {
      id: 6,
      name: "AI-Powered-Assistant-Toolkit",
      imageUrl:machine,
      websiteUrl: "https://github.com/ErnestH1/AI-Powered-Assistant-Toolkit",//https://banks-of-flatiron.vercel.app/
    },
    // {
    //   id: 6,
    //   name: "Bank",
    //   imageUrl: Bank,
    //   websiteUrl: "https://banks-of-flatiron.vercel.app/",
    // },
  ];

  return (

    <section id="projects">
    <div className="my-projects-container">
      <h2>My Projects</h2>
      <div className="projects-grid">
        {projects.map((project) => (
          <div key={project.id} className="project-card">
            <a href={project.websiteUrl} target="_blank" rel="noopener noreferrer">
              <div className="project-image" style={{ backgroundImage: `url(${project.imageUrl})` }}></div>
            </a>
            <div className="project-details">
              <h3>{project.name}</h3>
              <a href={project.websiteUrl} target="_blank" rel="noopener noreferrer">
                <button>View Details</button>
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
    </section>
  );
};

export default MyProjects;
